import { render, staticRenderFns } from "./transcript-link-project-modal.vue?vue&type=template&id=2e460572&"
import script from "./transcript-link-project-modal.vue?vue&type=script&lang=js&"
export * from "./transcript-link-project-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e460572')) {
      api.createRecord('2e460572', component.options)
    } else {
      api.reload('2e460572', component.options)
    }
    module.hot.accept("./transcript-link-project-modal.vue?vue&type=template&id=2e460572&", function () {
      api.rerender('2e460572', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/crm/modal/transcript-link-project-modal/transcript-link-project-modal.vue"
export default component.exports